// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"ae83cedc","453":"d855a71b","905":"8621f44b"}[chunkId] + ".chunk.js";
};